import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { Stack as l } from "@mui/joy";
import { memo as o } from "react";
import a from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import s from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import r from "../../labels/CredentialsLabel/CredentialsLabel.js";
const n = o(() => /* @__PURE__ */ e.jsxs(l, { children: [
  /* @__PURE__ */ e.jsx(s, {}),
  /* @__PURE__ */ e.jsx(a, { label: "Warehouse name", name: "snowflake.sourceConfig.warehouseName", placeholder: 'e.g. "DEV_WAREHOUSE"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Database name", name: "snowflake.sourceConfig.databaseName", placeholder: 'e.g. "TEST_DATABASE"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Schema name", name: "snowflake.sourceConfig.schemaName", placeholder: 'e.g. "TEST_SCHEMA"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Table name", name: "snowflake.sourceConfig.tableName", placeholder: 'e.g. "DATA_TABLE"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Stage name", name: "snowflake.sourceConfig.stageName", placeholder: 'e.g. "my_int_stage"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Stored dataset name", name: "datasetName", placeholder: 'e.g. "DQ_dataset_name"', required: !1 }),
  /* @__PURE__ */ e.jsx(r, {}),
  /* @__PURE__ */ e.jsx(a, { label: "Account ID", name: "snowflake.credentials.accountId", placeholder: 'e.g. "sdkreui-mt37045"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Username", name: "snowflake.credentials.username", placeholder: 'e.g. "testuser"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Password", name: "snowflake.credentials.password", placeholder: 'e.g. "Cfw3{?F^K46m(fj"', type: "masked" })
] }));
n.displayName = "SnowflakeFormControls";
export {
  n as default
};
//# sourceMappingURL=SnowflakeFormControls.js.map
